import type { FaireProductEntity } from "../../entity_types/product";

export const p_m84mzvyxma: FaireProductEntity = {
  token: "p_m84mzvyxma",
  type: "product",
  name: "Mushroom Mandala Propagation Station",
  brandToken: "b_x9gc7rccbx",
  brandName: "Mars & Me",
  imageUrl:
    "https://cdn.faire.com/fastly/ae20adcf687c5b737f47318d002dd414b6ef73a4c314ee0141129e243f445aa8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c8429b4f132b3f6e371f6bd0cce4b4cfa22ff0104d4c0d24927c2dd988db1dd1.jpeg",
    "https://cdn.faire.com/fastly/18b4c0ff95d6121e252a6bd84e30dcc43cd2846116c409e45ae0041a6694c959.jpeg",
    "https://cdn.faire.com/fastly/33244ccacb7c57fff123bacb6621b52dc804a6d386439a29ee29f61b70cbf4fa.jpeg",
  ],
  priceDollars: 19.4,
  description:
    'Double layer, single tube, 9.5"x5.5" laser cut mandala mushroom propagation station.',
  tags: [],
  msrpDollars: 38.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:17.655Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
